import React, { useEffect } from "react";
import useSalesReceiptStore from "../store";
import { ArrowRepeat } from "react-bootstrap-icons";
import { useParams, useSearchParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "../../api/api";
export default function GrandTotal({ getSalesReceiptData, refetching }) {
  const {
    categoryWiseSales,
    liabilities,
    discounts,
    tenderTypes,
    cashAccounts,
    expenses,
    creditCardFees,
    askMyClient,
    cashOverUnderEditable,
    cashOverUnder,
    grandTotall,
    setGrandTotall,
    serviceRevenue,
    grandTotalNew,
  } = useSalesReceiptStore();

  const calculateGrandTotal = () => {
    const totalSales = categoryWiseSales.reduce((acc, category) => {
      if (category["category"] === "Gift Card") {
        return acc;
      }
      const grossAmt =
        parseFloat(category["Gross Amount"]) - parseFloat(category["Refund"]);

      if (!isNaN(grossAmt)) {
        return acc + grossAmt;
      }

      return acc;
    }, 0);

    const totalLiabilities = liabilities.reduce((acc, liability) => {
      if (liability.liability_name.toLowerCase() !== "Total") {
        acc += parseFloat(liability.liability_amount);
      }
      return acc;
    }, 0);

    const totalDiscounts = discounts.reduce(
      (acc, discount) => acc + discount.discount_amount,
      0
    );

    const totalTenderTypes = tenderTypes.reduce(
      (acc, tender) => acc + tender.amount,
      0
    );

    const totalCashAccounts = cashAccounts.reduce(
      (acc, cashAccount) => acc + parseFloat(cashAccount.cash_accounts_amount),
      0
    );

    const totalExpenses = expenses.reduce(
      (acc, expense) => acc + expense.expenses_amount,
      0
    );

    const totalServiceRevenue = serviceRevenue.reduce(
      (acc, service) => acc + parseFloat(service.service_revenue_amount),
      0
    );

    console.log(
      totalSales,
      totalLiabilities,
      totalDiscounts,
      totalTenderTypes,
      totalCashAccounts,
      totalExpenses
    );
    const grandTotal = parseFloat(
      (
        totalSales +
        totalServiceRevenue +
        totalLiabilities +
        totalDiscounts +
        totalTenderTypes +
        totalCashAccounts +
        totalExpenses -
        (creditCardFees?.amount !== ""
          ? parseFloat(creditCardFees?.amount)
          : 0) +
        (askMyClient?.amount && askMyClient?.amount !== ""
          ? parseFloat(askMyClient?.amount)
          : 0) +
        (cashOverUnderEditable?.amount && cashOverUnderEditable?.amount !== ""
          ? parseFloat(cashOverUnderEditable?.amount)
          : 0) +
        (cashOverUnder?.amount && cashOverUnder?.amount !== ""
          ? parseFloat(cashOverUnder?.amount)
          : 0)
      ).toFixed(2)
    );

    return grandTotal;
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();
  const date = searchParams.get("date");
  const { mutate, isPending } = useMutation({
    mutationFn: async (body) => {
      const response = await instance.post(
        "/calculate-and-update-grand-total",
        body
      );
      return response.data;
    },
    onSuccess: async (data) => {
      getSalesReceiptData();
      toast.success(data.message);
    },
    onError: async (error) => {
      console.log("first error", error);
      toast.error("Error calculating grand total");
    },
  });

  useEffect(() => {
    const grandTotal = calculateGrandTotal();
    setGrandTotall(grandTotal);
  }, [
    categoryWiseSales,
    liabilities,
    discounts,
    tenderTypes,
    cashAccounts,
    expenses,
    creditCardFees,
    askMyClient,
    cashOverUnderEditable,
    cashOverUnder,
  ]);

  return (
    <div
      className="mx-3 my-4 border-white rounded shadow-sm p-3 bg-body-tertiary"
    >
      <div className="d-flex">
        <h4>Grand Total</h4>
        {isPending ? (
          <Spinner size="sm" animation="border" variant="primary" className="my-2 mx-2" />
        ) : (
          <ArrowRepeat
            className="my-2 mx-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const body = {
                restaurant_id: id,
                report_date: date,
              };
              mutate(body);
            }}
          />
        )}
      </div>
      <div className="row my-2">
        <div className="col-md-12 row">
          <div className="mb-3 col-md-12">
            {refetching ? (
              <input
                id="grand-total"
                name="grand-total"
                type="text"
                className="form-control"
                value={"Calculating..."}
                readOnly
                disabled
              />
            ) : (
              <input
                id="grand-total"
                name="grand-total"
                type="text"
                className="form-control"
                value={
                  typeof grandTotalNew === "number"
                    ? grandTotalNew.toFixed(2)
                    : grandTotalNew
                }
                readOnly
                disabled
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
